import DrillDownInteraction from './drillDown';
export var INTERACTION_MAP = {
    drilldown: DrillDownInteraction,
};
//# sourceMappingURL=index.js.map